import React from "react";
import { Container, CssBaseline, Box } from "@mui/material";
import NavigationBar from "./NavigationBar"; // Adjust path as needed
import Footer from "./Footer"; // Adjust path as needed

const Layout = ({ children }) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <CssBaseline /> {/* Normalize CSS */}
      <NavigationBar />
      <Container maxWidth="lg" sx={{ flex: 1 }}>
        <Box component="main" sx={{ my: 4 }}>
          {children}
        </Box>
      </Container>
      <Footer />
    </Box>
  );
};

export default Layout;
